import { memo } from "react"
import { DragOverlay } from "@dnd-kit/core"

function SortableOverlayComponent({ children }) {
  return (
    <DragOverlay
      dropAnimation={{ duration: 500, easing: "cubic-bezier(0.25, 1, 0.5, 1)" }}
    >
      {children}
    </DragOverlay>
  )
}

export const SortableOverlay = memo(SortableOverlayComponent)